// extracted by mini-css-extract-plugin
export default {"style":"FormulaireAxe_style__I036k","input":"FormulaireAxe_input__3FV41"};